var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pb-4"},[_c('CCard',{staticClass:"mt-md-3"},[_c('TermsTxt')],1),_vm._v(" "),_c('CBackToTop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }